<div class="nimbus-grid-wrapper">
  @if (loading) {
    <nimbus-spinner [small]="false"></nimbus-spinner>
  }
  <div class="nimbus-grid-table" (scroll)="scrollSubject$.next($event)">
    <table
      mat-table
      matSort
      multiTemplateDataRows
      [trackBy]="trackBy"
      [matSortDisableClear]="!sortable.allowUnsort"
      [matSortActive]="active"
      [matSortDirection]="direction"
      [dataSource]="view.data"
      (matSortChange)="onSortChange($event)"
    >
      <ng-container matColumnDef="expandedColumn" [sticky]="false" [stickyEnd]="false">
        <thead>
          <th *matHeaderCellDef mat-header-cell></th>
        </thead>
        <tbody>
          <td *matCellDef="let element" mat-cell>
            @if (detailsTemplate.showIf ? detailsTemplate.showIf(element) : true) {
              <span>
                <i [hidden]="!element.expanded" [nimbusIcon]="icons.CHEVRON_DOWN_LIGHT" (click)="element.expanded = false"></i>
                <i [hidden]="element.expanded" [nimbusIcon]="icons.CHEVRON_RIGHT_LIGHT" (click)="element.expanded = true"></i>
              </span>
            }
          </td>
        </tbody>
      </ng-container>

      @for (column of columns; track column) {
        <ng-container [matColumnDef]="column.field" [sticky]="false" [stickyEnd]="false">
          <thead>
            <th
              *matHeaderCellDef
              mat-header-cell
              mat-sort-header
              [disabled]="!column.sortable"
              [title]="column.title"
              [class]="column.headerClasses"
            >
              @if (column.headerTemplateRef) {
                <ng-template *ngTemplateOutlet="column.headerTemplateRef"></ng-template>
              } @else {
                {{ column.title }}
              }
            </th>
          </thead>
          <tbody>
            <td mat-cell *matCellDef="let element; let rowIndex = dataIndex" [class]="column.classes">
              <ng-template *ngTemplateOutlet="column.templateRef; context: { dataItem: element, rowIndex: rowIndex }"></ng-template>
            </td>
          </tbody>
        </ng-container>
      }

      <ng-container matColumnDef="expandedRow">
        <ng-container *matCellDef="let element; let rowIndex = dataIndex">
          @if (isExpandedEmptyCellDisplayed) {
            <td mat-cell></td>
          }
          <td mat-cell [attr.colspan]="columnsDisplayed.length - (isExpandedEmptyCellDisplayed ? 1 : 0)">
            <div>
              @if (element.expanded) {
                <ng-template
                  *ngTemplateOutlet="detailsTemplate.templateRef; context: { dataItem: element, rowIndex: rowIndex }"
                ></ng-template>
              }
            </div>
          </td>
        </ng-container>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsDisplayed; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let dataItem; columns: columnsDisplayed; when: isDataRow"
        [class.selected]="isSelected(dataItem) || isRowSelected(dataItem)"
        [class]="getRowClass(dataItem)"
        [attr.tabindex]="selectable.enabled ? 0 : null"
        [attr.role]="selectable.enabled ? 'row' : null"
        (click)="onSelect(dataItem)"
        (keydown.enter)="onSelect(dataItem)"
      ></tr>
      <tr mat-row *matRowDef="let dataItem; columns: ['expandedRow']; when: isDataRow" [hidden]="!dataItem.expanded"></tr>
      @if (showNoDataRow) {
        <tr *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="columnsDisplayed.length">
            {{ noRowsPlaceholder || TranslationKeys.GeneralGridNoRecords | translate }}
          </td>
        </tr>
      }

      <ng-container matColumnDef="groupHeader">
        <td *matCellDef="let group" mat-cell [attr.colspan]="columnsDisplayed.length">
          @if (!group.closed) {
            <i [nimbusIcon]="icons.CHEVRON_DOWN"></i>
          }
          @if (group.closed) {
            <i [nimbusIcon]="icons.CHEVRON_RIGHT"></i>
          }
          <strong>{{ group.name }}</strong>
        </td>
      </ng-container>

      <tr *matRowDef="let row; columns: ['groupHeader']; when: isGroup" mat-row (click)="onGroupHeaderClick(row)"></tr>
    </table>
  </div>

  @if (pageable) {
    <nimbus-grid-pager
      [total]="view.total"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [buttonCount]="pageable.buttonCount"
      [showFirstLastButtons]="pageable.showFirstLastButtons"
      [hideRangeLabel]="pageable.hideRangeLabel"
      (pageIndexChange)="onPageIndexChange($event)"
    ></nimbus-grid-pager>
  }
</div>
